<div>
    <h6>Welcome to Recovery Inventory Management!</h6>
</div>